import {management} from '../../../index'
import {SoilRepository} from '../../infra/knex/repositories/soil'

import {CreateSoilUseCase} from './createSoilUseCase'
import {DeleteSoilByIdUseCase} from './deleteSoilByIdUseCase'
import {ShowSoilUseCase} from './showSoilUseCase'
import {ShowSoilByIdUseCase} from './showSoilByIdUseCase'
import {UpdateSoilByIdUseCase} from './updateSoilUseCase'
import {UpdateFkEditorUseCase} from './updateFkEditorUseCase'
import { GetSoilIdByNameUseCase } from './getSoilIdByNameUseCase'


export const soilUseCase=()=>{
  const repository=new SoilRepository(management)

  const add=new CreateSoilUseCase(repository)
  const del=new DeleteSoilByIdUseCase(repository)
  const showSoilByIdUseCase=new ShowSoilByIdUseCase(repository)
  const show=new ShowSoilUseCase(repository)
  const edit=new UpdateSoilByIdUseCase(repository)
  const updateFkEditor=new UpdateFkEditorUseCase(repository)
  const getSoilIdByName =new GetSoilIdByNameUseCase(repository)

  return{
    add,
    del,
    showSoilByIdUseCase,
    show,
    edit,
    updateFkEditor,
    getSoilIdByName
  }
}
